(function(window, document, $, _){
	overwatch.buy = overwatch.buy || {};
	overwatch.buy.scroll = overwatch.buy.scroll || {};
	overwatch.buy.scroll.init = function() {
		var $doc = $(document);
		var $learnMoreContainer = $('.learn-more-tip-container');
		var $activeDetail = false;
		var activeDetailTop = 0;
		
		// wait til dom is ready before reading boundingRect values
		$doc.on('ready', function(event){
			
			var visible = 1;
			
			// handles hiding the scroll btn and removes scroll event
			function hideScroll(){
				visible = 0;
				$doc.off('scroll.learnmore');
				$learnMoreContainer.velocity('fadeOut', {
					duration: 200,
					easing: 'easeOutQuart',
					complete: function(){
						$learnMoreContainer.detach();
					}
				});
			};
			$activeDetail = $('.detail.active');
			activeDetailTop = $activeDetail.offset().top;
			
			// handle page scroll on btn click
			$learnMoreContainer.on('click', function(event){
				event.preventDefault();
				if(visible){
					$activeDetail = $('.detail.active');
					activeDetailTop = $activeDetail.offset().top;
					$activeDetail.velocity('scroll', {
						duration: 200,
						easing: 'easeOutQuart'
					});
					hideScroll();
				}
			});
			
			var hideIfScrolledFarEnough = _.debounce(function(e) {
				if(activeDetailTop <= $doc.scrollTop()) {
					hideScroll();
					$(window).off('scroll', hideIfScrolledFarEnough);
				}
			}, 100);
			
			if($learnMoreContainer.length > 0) {
				$(window).on('scroll', hideIfScrolledFarEnough);
			}
		});
	};
	
})(window, window.document, window.jQuery, window._);
